export const Rights = [
    "WEB_MODULE_HELICOPTER_PILOTAGES_READ"   
]
